import React from 'react';
import { View, ViewStyle } from 'react-native';

import { useTheme } from '@/components/theme-provider';

export interface SurfaceProps {
	children: React.ReactNode;
	style?: ViewStyle;
	elevation?: number;
}

export const Surface: React.FC<SurfaceProps> = ({ children, style, elevation = 0 }) => {
	const theme = useTheme();

	const surfaceStyle: ViewStyle = {
		backgroundColor: theme.colors.surface,
		...(elevation > 0 && {
			shadowColor: theme.colors.shadow,
			shadowOffset: { width: 0, height: elevation },
			shadowOpacity: 0.1,
			shadowRadius: elevation,
			elevation: elevation,
		}),
	};

	return (
		<View style={[surfaceStyle, style]}>
			{children}
		</View>
	);
};
